<template>
  <div>
    <div class="columns has-bg-light is-border-bottom is-border-dashed ">
      <div class="column">
        <router-link :to="{name: 'SaleStats'}">
          <span class="has-text-grey has-text-weight-normal is-size-6">
              <span class="has-text-weight-normal">Période de</span>
              <span class="has-text-grey has-text-weight-normal is-dotted">
                {{startDateLabel | uppercase}}
              </span>
              <span class="has-text-weight-normal">à</span>
              <span class="has-text-grey has-text-weight-normal is-dotted">
                {{endDateLabel | uppercase}}
              </span>
          </span>
        </router-link>
      </div>
    </div>

    <div class="day-view is-border-bottom is-border-dashed">
      <div class="columns is-vcentered">
        <div class="column is-padding-bottom contacts">
          <p class="is-padding-bottom-small has-text-grey is-size-6">{{usersCount}} Membre(s) dans la structure</p>
          <span
            class="is-inline-block is-vcentered is-margin-right-xsmall is-margin-bottom-xsmall is-selected tooltip is-tooltip-bottom"
            v-for="(u, i) in users.slice(0, 6)" :key="u.pk" :data-tooltip="`${u.last_name} ${u.first_name}`">
            <avatar :item="u" :i="i"></avatar>
          </span>
          <router-link :to="{name: 'UserList'}"
                       class="is-inline-block is-vcentered is-margin-right-xsmall is-margin-bottom-xsmall is-selected"
                       v-if="usersCount > 6">
            <span class="avatar" :class="'avatar-01'">
              <span>{{usersCount - 6}}+</span>
            </span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="column has-text-grey is-size-6 is-padding-bottom-xsmall">
      <p>CA prix immo <span class="has-text-weight-normal">sur la période du</span>
        <span class="has-text-grey has-text-weight-normal">{{startDate.format('DD MMMM YYYY')}}</span>
        <span class="has-text-weight-normal">au</span>
        <span class="has-text-grey has-text-weight-normal">{{endDate.format('DD MMMM YYYY')}}</span>
      </p>
      <span class="has-text-draft has-text-weight-bold"><em>(Réservations + ventes actées)</em></span>
    </div>

    <div class="column is-border-bottom is-border-dashed is-padding-top-xsmall">
      <span class="is-size-1 has-text-weight-medium is-inline-block">{{totalCA | prettyPrice}} {{$currency}} </span>
      <sup v-if="evoTotalCA" class="is-size-5">
        <i class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
           :class="evoTotalCA > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
      </sup>
      <br><span class="is-size-7" v-if="evoTotalCA"
                :class="evoTotalCA > 0 ? 'has-text-success' : 'has-text-danger'">
        <span v-if="evoTotalCA && evoTotalCA > 0">+ </span>{{evoTotalCA}} %
        <span class="has-text-draft">par rapport à la période du {{previousStartDate}} au {{previousEndDate}}</span>
      </span>
    </div>

    <div class="column has-text-grey is-size-6 is-paddingless-bottom" v-if="showGoals">
      Objectif CA {{startDate.format('YYYY')}} : {{totalGoals | prettyPrice}} {{$currency}}
    </div>
    <div class="column is-border-bottom is-border-dashed" v-if="showGoals && progressGoals">
      <progress class="progress is-success is-small" :value="progressGoals" max="100">{{progressGoals}} %</progress>
    </div>

    <div class="column columns is-paddingless">
      <div
        class="column is-paddingless is-4 is-border-bottom is-border-right is-border-dashed graph-over graph-over--decoration"
        @click="goToRoute('AdvList', {status: 'reserved'})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Résa en cours</div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold graph-over">{{pendingResa}}</span>
          <sup v-if="showfakeStats" class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall is-rotate-315 has-text-success"></i>
          </sup>
          <sup v-else-if="evoPendingResa" class="is-size-5">
            <i class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
               :class="evoPendingResa > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
          </sup>
          <br>
          <span class="is-size-7 has-text-success" v-if="showfakeStats">
            <span>+ </span>25 %
          </span>
          <span class="is-size-7" v-else-if="evoPendingResa"
                :class="evoPendingResa > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoPendingResa && evoPendingResa > 0">+ </span>{{evoPendingResa}} %
          </span>
        </div>
      </div>
      <div
        class="column is-paddingless is-4 is-border-bottom is-border-right is-border-dashed graph-over graph-over--decoration"
        @click="goToRoute('AdvList', {status: 'canceled_by_admin'})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Résa annulées</div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold graph-over">{{canceledResa}}</span>
          <sup v-if="showfakeStats" class="is-size-5">
            <i class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall is-rotate-45 has-text-danger"></i>
          </sup>
          <sup v-else-if="evoCanceledResa" class="is-size-5">
            <i class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
               :class="evoCanceledResa > 0 ? 'is-rotate-45 has-text-danger' : 'is-rotate-315 has-text-success'"></i>
          </sup>
          <br>
          <span class="is-size-7 has-text-danger" v-if="showfakeStats">
            <span>- 15 %</span>
          </span>
          <span class="is-size-7" v-else-if="evoCanceledResa"
                :class="evoCanceledResa > 0 ? 'has-text-danger' : 'has-text-succes'">
            <span v-if="evoCanceledResa && evoCanceledResa > 0">+ </span>{{evoCanceledResa}} %
          </span>
        </div>
      </div>
      <div
        class="column is-paddingless is-4 is-border-bottom is-border-right is-border-dashed has-bg-light graph-over graph-over--decoration"
        @click="goToRoute('CalendarList', {date__gte: todayMin, date__lte: endOfYear})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Rendez-vous à venir ({{currentYear}})</div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold graph-over">{{futureRdvCount}}</span>
        </div>
      </div>
    </div>

    <div class="column columns is-paddingless">
      <div
        class="column is-paddingless is-6 is-border-bottom is-border-right is-border-dashed graph-over graph-over--decoration"
        @click="goToRoute('AdvList', {status: 'sold'})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Ventes actées</div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold graph-over">{{soldCount}}</span>
          <sup v-if="showfakeStats" class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall is-rotate-315 has-text-success"></i>
          </sup>
          <sup v-else-if="evoSoldCount" class="is-size-5">
            <i class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
               :class="evoSoldCount > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
          </sup>
          <br>
          <span class="is-size-7 has-text-success" v-if="showfakeStats">
            <span>+ </span>35 %
          </span>
          <span class="is-size-7" v-else-if="evoSoldCount"
                :class="evoSoldCount > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoSoldCount && evoSoldCount > 0">+ </span>{{evoSoldCount}} %
          </span>
        </div>
      </div>
      <div
        class="column is-paddingless is-6 is-border-bottom is-border-right is-border-dashed graph-over graph-over--decoration"
        @click="goToRoute('SaleStats')">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Prix de vente moyen</div>
        <div class="column">
          <span class="is-size-4 has-text-weight-bold graph-over"
                v-if="moyCA">{{moyCA | prettyPrice}} {{$currency}} </span>
          <span class="is-size-4 has-text-weight-bold graph-over" v-else>0</span>
          <sup v-if="showfakeStats" class="is-size-5">
            <i
              class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall is-rotate-315 has-text-success"></i>
          </sup>
          <sup v-else-if="evoMoyCA" class="is-size-5">
            <i class="fal fa-arrow-right is-inline-block is-top is-margin-top-xsmall"
               :class="evoMoyCA > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
          </sup>
          <br>
          <span class="is-size-7 has-text-success" v-if="showfakeStats">
            <span>+ </span>13.5 %
          </span>
          <span class="is-size-7" v-else-if="evoMoyCA"
                :class="evoMoyCA > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoMoyCA && evoMoyCA > 0">+ </span>{{evoMoyCA}} %
          </span>
        </div>
      </div>
    </div>

    <div class="column columns is-paddingless">
      <div class="column is-paddingless is-6 is-border-bottom is-border-right is-border-dashed"
           v-if="bestSeller && checkEmpty(bestSeller)"
           @click="goToRoute('UserVue', null, {id: bestSeller.id})">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Plus forte activité</div>
        <div class="column is-padding-top-xsmall">
          <span class="is-size-4 has-text-weight-bold graph-over">{{bestSeller.name}}</span>
          <br>
          <span class="is-size-7 has-text-weight-light">
            {{bestSeller.saleCount}} vente(s) actée(s)
            <br>{{bestSeller.resaCount}} réservation(s) en cours
            <br>{{bestSeller.rdvCount}} RDV à venir
          </span>
        </div>
      </div>
      <div class="column is-paddingless is-6 is-border-bottom is-border-right is-border-dashed"
           v-if="bestCompany && checkEmpty(bestCompany)"
           @click="bestCompany.id ? goToRoute('CompanyVue', null, {id: bestCompany.id}) : goToRoute('CompanyList')">
        <div class="column is-size-6 has-text-grey is-paddingless-bottom">Société la plus active</div>
        <div class="column is-padding-top-xsmall">
          <span class="is-size-4 has-text-weight-bold graph-over">
              {{bestCompany.name}}
          </span>
          <br>
          <span class="is-size-7 has-text-weight-light">
            {{bestCompany.saleCount}} vente(s) actée(s)
            <br>{{bestCompany.resaCount}} réservation(s) en cours
          </span>
        </div>
      </div>
    </div>

    <div class="column is-paddingless-left is-paddingless-right is-padding-top-xsmall is-padding-bottom-xsmall">
      <router-link :to="{name: 'SaleStats'}" class="button is-white is-size-7 is-paddingless-right">
        <span class="icon is-small">
            <i class="fal fa-chart-bar"></i>
        </span>
        <span class="is-padding-right-small">Toutes les statistiques</span>
      </router-link>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker'
  import { isEmpty, groupBy, sortBy, last } from 'lodash'
  import moment from 'moment'

  export default {
    name: 'StatsActivity',
    data () {
      return {
        currentYear: moment().format('YYYY'),
        rawStartDate: null,
        rawEndDate: null,
        todayMin: moment().format('DD/MM/YYYY'),
        endOfYear: moment().endOf('year').format('DD/MM/YYYY')
      }
    },
    components: { Datepicker },
    props: {
      periodSales: Array,
      previousPeriodSales: Array,
      endDate: Object,
      startDate: Object,
      users: Array,
      usersCount: Number,
      yearSales: Array,
      futureRdvCount: Number,
      futureRdv: Array
    },
    computed: {
      showfakeStats () {
        return JSON.parse(this.$configs.FAKE_STATS) === 1
      },
      endDateLabel () {
        return this.endDate.format('MMMM YYYY')
      },
      startDateLabel () {
        return this.startDate.format('MMMM YYYY')
      },
      disabledDates () {
        return {
          to: this.rawStartDate
        }
      },
      sales () {
        return this.periodSales
      },
      previousSales () {
        return this.previousPeriodSales
      },
      pendingResa () {
        return this.sales.filter(x => x.status === 'reserved').length
      },
      evoPendingResa () {
        if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
          let previousPendings = this.previousSales.filter(x => x.status === 'reserved').length
          return ((previousPendings / this.pendingResa) * 100).toFixed(2)
        } else return null
      },
      canceledResa () {
        return this.sales.filter(x => x.status === 'canceled_by_admin').length
      },
      evoCanceledResa () {
        if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
          let previousCancels = this.previousSales.filter(x => x.status === 'canceled_by_admin').length
          return ((previousCancels / this.canceledResa) * 100).toFixed(2)
        } else return null
      },
      soldCount () {
        return this.sales.filter(x => x.status === 'sold').length
      },
      evoSoldCount () {
        if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
          let previousSold = this.previousSales.filter(x => x.status === 'sold').length
          return ((previousSold / this.soldCount) * 100).toFixed(2)
        } else return null
      },
      totalCA () {
        return this.sales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
          return a + b.sale_price_with_discount
        }, 0)
      },
      totalYearCA () {
        return this.yearSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
          return a + b.sale_price_with_discount
        }, 0)
      },
      evoTotalCA () {
        if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
          let previousCA = this.previousSales.filter(x => ['sold', 'reserved'].includes(x.status)).reduce((a, b) => {
            return a + b.sale_price_with_discount
          }, 0)
          return ((previousCA / this.totalCA) * 100).toFixed(2)
        } else return null
      },
      moyCA () {
        let sold = this.sales.filter(x => ['sold', 'reserved'].includes(x.status))
        if (!sold.length) return
        return this.totalCA / sold.length
      },
      evoMoyCA () {
        if (!isEmpty(this.sales) && !isEmpty(this.previousSales)) {
          let currentMoy = this.sales.filter(x => ['sold', 'reserved'].includes(x.status))
          let currentMoyVal = currentMoy.reduce((a, b) => {
            return a + b.sale_price_with_discount
          }, 0) / currentMoy.length
          let previousMoy = this.previousSales.filter(x => ['sold', 'reserved'].includes(x.status))
          let previousMoyVal = previousMoy.reduce((a, b) => {
            return a + b.sale_price_with_discount
          }, 0) / previousMoy.length
          return ((currentMoyVal - previousMoyVal) / previousMoyVal * 100).toFixed(2)
        } else return null
      },
      totalGoals () {
        let goals = []
        this.users.filter(x => x.goals && x.goals.length).forEach(x => {
          x.goals.filter(y => {
            if (Number(y.year) === Number(this.startDate.format('YYYY'))) return goals.push(y.goal)
          })
        })
        return goals.reduce((a, b) => {
          return a + Number(b)
        }, 0)
      },
      progressGoals () {
        return this.totalYearCA / this.totalGoals * 100
      },
      showGoals () {
        return this.progressGoals && this.progressGoals >= 0 && this.totalGoals && this.totalGoals >= 0 && isNaN(this.totalGoals) === false && isNaN(this.progressGoals) === false
      },
      previousStartDate () {
        let startDate = this.startDate.clone().startOf('month')
        let endDate = this.endDate.clone().endOf('month')
        let delta = endDate.diff(startDate, 'days')
        return startDate.clone().subtract(delta, 'days').format('DD MMMM YYYY')
      },
      previousEndDate () {
        let startDate = this.startDate.clone().startOf('month')
        let endDate = this.endDate.clone().endOf('month')
        let delta = endDate.diff(startDate, 'days')
        return endDate.clone().subtract(delta, 'days').format('DD MMMM YYYY')
      },
      bestSeller () {
        let sales = this.sales.filter(x => x.status === 'sold')
        let resa = this.sales.filter(x => x.status === 'reserved')
        let groupSale = groupBy(sales, 'seller')
        let groupResa = groupBy(resa, 'seller')
        let groupRdv = groupBy(this.futureRdv, 'seller')
        let users = this.users.map(x => {
          return {
            id: x.pk,
            name: `${x.first_name} ${x.last_name}`,
            saleCount: groupSale[x.pk] ? groupSale[x.pk].length : 0,
            rdvCount: groupRdv[x.pk] ? groupRdv[x.pk].length : 0,
            resaCount: groupResa[x.pk] ? groupResa[x.pk].length : 0
          }
        })
        let lastSeller = last(sortBy(users, x => {
          return x.saleCount + x.rdvCount + x.resaCount
        }))
        if (lastSeller && lastSeller.saleCount + lastSeller.resaCount > 0) {
          return lastSeller
        } else return null
      },
      bestCompany () {
        let sales = this.sales.filter(x => x.status === 'sold' && x.company_name !== null)
        let resa = this.sales.filter(x => x.status === 'reserved' && x.company_name !== null)
        let allSales = this.sales.filter(x => ['reserved', 'sold'].includes(x.status))
        let groupSale = groupBy(sales, 'seller')
        let groupResa = groupBy(resa, 'seller')
        let groupCompany = groupBy(allSales, 'company_name')
        groupCompany = Object.values(groupCompany).map(y => {
          return y.map(x => {
            return {
              id: x.company,
              name: x.company_name,
              companyId: x.company,
              saleCount: groupSale[x.seller] ? 1 : 0,
              resaCount: groupResa[x.seller] ? 1 : 0
            }
          }).reduce((a, b) => {
            return {
              name: b.name,
              id: b.id,
              saleCount: a.saleCount + b.saleCount,
              resaCount: a.resaCount + b.resaCount
            }
          }, { saleCount: 0, resaCount: 0 })
        })
        let lastCompany = last(sortBy(groupCompany, x => {
          return x.saleCount + x.resaCount
        }))
        if (lastCompany && lastCompany.saleCount + lastCompany.resaCount > 0) {
          return lastCompany
        } else return null
      }
    },
    methods: {
      openStartMonthPicker () {
        this.$refs.startDatePicker.showCalendar()
      },
      openEndMonthPicker () {
        this.$refs.endDatePicker.showCalendar()
      },
      updateStartDate (d) {
        this.$emit('updateStartDate', d)
      },
      updateEndDate (d) {
        this.$emit('updateEndDate', d)
      },
      checkEmpty (v) {
        return !isEmpty(v)
      },
      goToRoute (route, query, params) {
        let today = moment()
        if (route === 'AdvList' && query) {
          if (query.status === 'sold') {
            Object.assign(query, {
              sale_date__gte: this.startDate.format('DD/MM/YYYY'),
              sale_date__lte: today.format('DD/MM/YYYY')
            })
          } else {
            Object.assign(query, {
              signature_date__gte: this.startDate.format('DD/MM/YYYY'),
              signature_date__lte: today.format('DD/MM/YYYY')
            })
          }
        }
        this.$router.push({ name: route, query, params })
      }
    },
    created () {
      this.rawStartDate = new Date(this.startDate)
      this.rawEndDate = new Date(this.endDate)
    }
  }
</script>

<style>
  #startDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }

  #endDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/stats-panel/StatsActivity.vue